import React, { useEffect, useState } from 'react'
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import CompanyServiceRegistrationForm from '../components/CompanyServiceRegistraionForm';
import axios from 'axios';
import BASE_API_URL from '../apis/index';

function UserServiceEdit() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const servId = queryParams.get("servId");
    const compId = queryParams.get("compId");
    const compName = queryParams.get("compName");

    const [formData, setFormData] = useState(null);

    // fetch product Details
    useEffect(() => {
        if (!servId) return;

        const fetchService = async () => {
            try {
                const authToken = localStorage.getItem("authToken");
                const res = await axios.get(`${BASE_API_URL}/api/seller/service/${servId}`, { 
                    headers: { Authorization: `Bearer ${authToken}` } 
                });

                const service = res.data;
                // 🔹 Parse stored JSON fields
                const dosageFormats = service.dosage_formats ? JSON.parse(service.dosage_formats) : [];
                const specialities = service.specialities ? JSON.parse(service.specialities) : [];
                const capabilities = service.capabilities ? JSON.parse(service.capabilities) : [];
                const packaging = service.packaging ? JSON.parse(service.packaging) : [];

                // 🔹 Parse supporting documents
                const existingDocs = service.supporting_documents ? JSON.parse(service.supporting_documents) : [];
                const existingDocNames = service.document_names ? JSON.parse(service.document_names) : [];
                const mergedExistingDocs = existingDocs.map((file, i) => ({
                    id: i,
                    file, // URL from backend
                    name: existingDocNames[i] || file
                }));

                setFormData({
                    dosageFormats,
                    specialities,
                    capabilities,
                    packaging,
                    existingDocuments: mergedExistingDocs, // prefill docs
                    documents: null,
                    image: service.image || null
                });
            } catch (err) {
                console.error(err);
            }
        };

        fetchService();
    }, [servId]);

    return (
        <Wrapper className='container'>
            <Breadcrumbs aria-label="breadcrumb" className="mb-5 mt-2 pageBreadCrumbs">
                <Link color="inherit" href={`/user-company-details?compId=${compId}`}> {compName} </Link>
                <Typography className='text-secondary'> Editing Service </Typography>
            </Breadcrumbs>

            <h2 className="pageTitle after_title_line"> Edit Service of <span className="txt_color_secondary">{compName}</span> </h2>

            <CompanyServiceRegistrationForm
                compId={compId}
                compName={compName}
                initialData={formData}
                isEdit={true}
                serviceId={servId}
            />

        </Wrapper>
    )
}

export default UserServiceEdit;

const Wrapper = styled.div``;